var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlusCircle = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1008 1008",
  width: "1em",
  height: "1em",
  role: "img",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M504 0c278 0 504 226 504 504s-226 504-504 504S0 782 0 504 226 0 504 0m0 972c258 0 468-210 468-468S762 36 504 36 36 246 36 504s210 468 468 468m18-756v270h270v36H522v270h-36V522H216v-36h270V216z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlusCircle);
export default ForwardRef;